<template>
  <div class="m-12 mx-0 mt-2 flex flex-col w-auto">
    <!-- <div class="w&#45;full flex flex&#45;row justify&#45;between p&#45;4 px&#45;0"> -->
    <!--   <breadcrumbs :links="links"></breadcrumbs> -->
    <!-- </div> -->
    <main id="narrative-canvas" class="w-auto relative" style="height:12000px">
      <div id="image-holder" style="position:relative; opacity:0.0; z-index:-1">
        <img
          id="pic1"
          style="position: fixed; top:0; left: 0; height:100%; width: 100%
          opacity: 0; z-index:-1; object-fit:cover; object-position: 50% 50%"
          src="https://argos.michaero.com/static/water-girl.gif"
        />
      </div>

      <div class="flex flex-col items-center justify-center">
        <span class="text-6xl text-gray-500">
          Welcome.
        </span>

        <span class="text-4xl text-gray-400 w-1/2 text-center">
          {{ narrative.description }}
        </span>

        <div class="text-lg font-semibold text-blue-500 mt-24 uppercase">
          Scroll to begin the narrative!
          <a href='http://www.nytimes.com'>CLICK ME</a>
        </div>

        <!-- DOWNWARD ARROW -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="h-12 text-blue-500"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 17l-4 4m0 0l-4-4m4 4V3"
          />
        </svg>
        <!-- END DOWNWARD ARROW -->
      </div>

      <!-- THIS IS WHERE CONTENT IS INJECTED -->

      <div id="fade-to-black"></div>
      <div class="tick"></div>
      <div class="tick"></div>
      <div class="tick"></div>
      <div class="tick"></div>
      <div id="giffy"></div>
      <div id="title-holder" class="relative z-10">
        <title-element
          id="title-element"
          class="scale-50"
          :options="options"
        ></title-element>
      </div>
    </main>
  </div>
</template>

<script>
// import Component from "../component_location"
import { reportError } from "@/utils.js";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Vue from "vue";
import VueScrollmagic from "vue-scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import TitleElement from "@/components/NarrativeElements/TitleElement.vue";
Vue.use(VueScrollmagic, { refreshInterval: 100 });

export default {
  components: { Breadcrumbs, TitleElement },

  props: ["username", "narrativeName"],

  data() {
    return {
      options: {
        title: "The Story of Water",
        author: "Matthew J. Lewis, Ph.D.",
        logo: "@/assets/springmatter-logo.png",
        logoClass: "h-8 mt-1",
        titleClass: "text-blue-500 font-semibold text-4xl",
        authorClass: "text-gray-200",
      },
    };
  },

  watch: {},

  methods: {
    createNarrative() {

      const fade = this.$scrollmagic
        .scene({
          triggerElement: "#fade-to-black",
          triggerHook: 0.25,
          duration: 100,
        })
        .setTween("#narrative-canvas", 0.5, {
          css: { backgroundColor: "#151515" },
        });

      const appear = this.$scrollmagic
        .scene({
          triggerElement: "#giffy",
          triggerHook: 0.25,
          duration: 200,
        })
        .setTween("#image-holder", 0.5, {
          css: { opacity: 0.999, zIndex: 10 },
        });

      const title = this.$scrollmagic
        .scene({
          triggerElement: "#title-holder",
          triggerHook: 0.75,
          duration: 400,
        })
        .setTween("#title-element", 0.5, {
          css: {
            opacity: 1,
            left: "50%",
            scale: 2.5,
          },
        });

      const pinTitle = this.$scrollmagic
        .scene({
          triggerElement: "#title-holder",
          triggerHook: 0.12,
          duration: 400,
        })
        .setPin("#title-holder");

      // ADD ALL SCENES
      this.$scrollmagic.addScene(fade);
      this.$scrollmagic.addScene(appear);
      this.$scrollmagic.addScene(title);
      this.$scrollmagic.addScene(pinTitle);
    },
  },

  computed: {
    links() {
      return [
        {
          name: this.$store.getters['users/nickname'] + "'s narratives",
          route: {
            name: "Narratives",
            params: { username: this.username },
          },
        },

        {
          name: this.narrativeName,
          route: {
            name: "Narrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },

        {
          name: "watch",
          route: {
            name: "WatchNarrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },
      ];
    },
    narrative() {
      return this.$store.state.narrative;
    },
  },

  mounted() {
    this.$samsa
      .getNarrative(this.username, this.narrativeName)
      .then((res) => {
        this.$store.commit("setNarrative", res.data);
        this.createNarrative();
      })
      .catch((err) => {
        reportError(err);
        this.$route.push({
          name: "Narratives",
          params: { username: this.username },
        });
      });
  },
};
</script>

<style>
.tick {
  height: 200px;
}
</style>
